<div class="wrapper margin-top">
    <div class="grid-x grid-margin-x">
        <div class="cell large-12 medium-12 small-12">
            <span class="bold margin-right">Inspectors by County:</span><span class="italic red">Note: Enter data <span class="bold">exactly</span> as you wish it to appear on printed documents (e.g., permits, etc.).</span>
        </div>
        <div class="cell alrge-12 medium-12 small-12 margin-bottom">
            <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data | async" aria-label="Manage Inspectors"></ag-grid-angular>
        </div>
        <div class="cell large-4 medium-4 small-4 text-align-right padding-right">
            Replace all instances of
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-left padding-right">
            <input type="text" [(ngModel)]="originalValue" />
        </div>
        <div class="cell large-1 medium-1 small-1 text-align-center">
            with
        </div>
        <div class="cell large-2 medium-2 small-2 text-align-left">
            <input type="text" [(ngModel)]="replacementValue" />
        </div>
        <div class="cell large-3 medium-3 small-3">
            <button (click)="confirmReplaceAll()" class="button">Replace</button>
        </div>
        <div class="cell large-12 medium-12 small-12 text-align-center">
            <span class="margin-right">
                <button class="button" (click)="cancel()">Exit Without Saving</button>
            </span>
            <span class="margin-left">
                <button class="button" (click)="submitChanges()">Submit Changes</button>
            </span>
        </div>
    </div>
</div>
